/*!
 * Cover König – Land & Sprache beim ersten Besuch automatisch einstellen
 * Land: von Shopify erkannt (IP), Sprache: Browsereinstellung des Besuchers.
 * Läuft nur einmal pro Besucher. Wählt der Besucher selbst Land oder Sprache, bleibt seine Wahl.
 * Suchmaschinen und Vorschau im Theme-Editor werden nicht umgestellt.
 */
(function () {
  'use strict';
  var KEY = 'ck_geo_v1';
  var store;
  try { store = window.localStorage; store.getItem(KEY); } catch (e) { return; }
  var ua = navigator.userAgent || '';
  if (navigator.webdriver || /bot|crawl|spider|slurp|bingpreview|lighthouse|pagespeed|headless|facebookexternalhit|embedly|whatsapp/i.test(ua)) return;
  if (window.Shopify && window.Shopify.designMode) return;

  function done() { try { store.setItem(KEY, String(Date.now())); } catch (e) {} }

  // Eigene Auswahl des Besuchers merken
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && /\/localization/.test(f.action)) done();
  }, true);

  if (store.getItem(KEY)) return;

  function options(sel) {
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (a) {
      var v = a.getAttribute('data-value');
      if (v && out.indexOf(v) < 0) out.push(v);
    });
    return out;
  }

  function run() {
    var locales = options('[data-disclosure-locale] [data-value]');
    var countries = options('[data-disclosure-currency] [data-value]');
    var curLocale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'de';
    var curCountry = (window.Shopify && window.Shopify.country) || '';

    // Sprache aus dem Browser: erst genaue Übereinstimmung (pt-PT), dann Grundsprache (pt → pt-PT)
    var wantLocale = null;
    var prefs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || '']);
    for (var i = 0; i < prefs.length && !wantLocale; i++) {
      var p = String(prefs[i] || '').toLowerCase();
      if (!p) continue;
      var base = p.split('-')[0];
      for (var j = 0; j < locales.length; j++) { if (locales[j].toLowerCase() === p) { wantLocale = locales[j]; break; } }
      if (!wantLocale) for (var k = 0; k < locales.length; k++) { if (locales[k].toLowerCase().split('-')[0] === base) { wantLocale = locales[k]; break; } }
    }
    // Sprache nicht im Shop (z. B. Tschechisch): Englisch statt Deutsch
    if (!wantLocale && String(prefs[0] || '').toLowerCase().split('-')[0] !== 'de') {
      for (var m = 0; m < locales.length; m++) { if (locales[m].toLowerCase().split('-')[0] === 'en') { wantLocale = locales[m]; break; } }
    }

    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .catch(function () { return {}; })
      .then(function (d) {
        var c = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        var wantCountry = c && countries.indexOf(c) >= 0 ? c : null;
        var changeLocale = wantLocale && wantLocale.toLowerCase() !== String(curLocale).toLowerCase();
        var changeCountry = wantCountry && wantCountry !== curCountry;
        done();
        if (!changeLocale && !changeCountry) return;

        // Pfad ohne Sprachpräfix, Shopify setzt den neuen Präfix selbst
        var path = window.location.pathname;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (root !== '/' && path.indexOf(root) === 0) path = '/' + path.slice(root.length);
        var f = document.createElement('form');
        f.method = 'post';
        f.action = '/localization';
        f.style.display = 'none';
        var add = function (n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); };
        add('form_type', 'localization');
        add('utf8', '✓');
        add('_method', 'put');
        add('return_to', path + window.location.search + window.location.hash);
        add('locale_code', changeLocale ? wantLocale : curLocale);
        if (wantCountry || curCountry) add('country_code', changeCountry ? wantCountry : curCountry);
        document.body.appendChild(f);
        f.submit();
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();

/* Cover König – Farbnamen auf der Seite „Farben“ (EComposer-Seite ohne Übersetzungsfelder) */
(function () {
  'use strict';
  var T = {
    en: ['colours', 'Anthracite', 'Black', 'Dark brown', 'Grey', 'Blue', 'Brown', 'Difference between Marine Vinyl and Weather Shield material'],
    nl: ['kleuren', 'Antraciet', 'Zwart', 'Donkerbruin', 'Grijs', 'Blauw', 'Bruin', 'Verschil tussen Marine Vinyl en Weather Shield-materiaal'],
    it: ['colori', 'Antracite', 'Nero', 'Marrone scuro', 'Grigio', 'Blu', 'Marrone', 'Differenza tra Marine Vinyl e materiale Weather Shield'],
    sv: ['färger', 'Antracit', 'Svart', 'Mörkbrun', 'Grå', 'Blå', 'Brun', 'Skillnaden mellan Marine Vinyl och Weather Shield-material'],
    da: ['farver', 'Antracit', 'Sort', 'Mørkebrun', 'Grå', 'Blå', 'Brun', 'Forskellen mellem Marine Vinyl og Weather Shield-materiale'],
    fr: ['couleurs', 'Anthracite', 'Noir', 'Brun foncé', 'Gris', 'Bleu', 'Marron', 'Différence entre Marine Vinyl et le matériau Weather Shield'],
    pt: ['cores', 'Antracite', 'Preto', 'Castanho escuro', 'Cinzento', 'Azul', 'Castanho', 'Diferença entre Marine Vinyl e o material Weather Shield'],
    es: ['colores', 'Antracita', 'Negro', 'Marrón oscuro', 'Gris', 'Azul', 'Marrón', 'Diferencia entre Marine Vinyl y el material Weather Shield'],
    pl: ['kolory', 'Antracyt', 'Czarny', 'Ciemnobrązowy', 'Szary', 'Niebieski', 'Brązowy', 'Różnica między Marine Vinyl a materiałem Weather Shield'],
    hr: ['boje', 'Antracit', 'Crna', 'Tamnosmeđa', 'Siva', 'Plava', 'Smeđa', 'Razlika između materijala Marine Vinyl i Weather Shield'],
    hu: ['színek', 'Antracit', 'Fekete', 'Sötétbarna', 'Szürke', 'Kék', 'Barna', 'A Marine Vinyl és a Weather Shield anyag közötti különbség']
  };
  function run() {
    var root = document.getElementById('ecom-69c2a1450d8c8a4f5501d574');
    if (!root) return;
    var loc = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'de').toLowerCase().split('-')[0];
    var t = T[loc];
    if (!t) return;
    var rules = [
      [/Unterschied zwischen Marine Vinyl und Weather Shield Material/g, t[7]],
      [/Dunkel\s*Braun|Dunkelbraun/g, t[3]],
      [/\bFarben\b/g, t[0]],
      [/\bAnthrazit\b/g, t[1]],
      [/\bSchwarz\b/g, t[2]],
      [/\bGrau\b/g, t[4]],
      [/\bBlau\b/g, t[5]],
      [/\bBraun\b/g, t[6]]
    ];
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = w.nextNode())) {
      var v = n.nodeValue, o = v;
      for (var i = 0; i < rules.length; i++) v = v.replace(rules[i][0], rules[i][1]);
      if (v !== o) n.nodeValue = v;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
